import React, { createContext, useContext } from 'react';
export const TvPackageStoreContext = createContext(null);
export const TvPackageStoreProvider = (props) => {
    const { tvPackageStore, children } = props;
    return React.createElement(TvPackageStoreContext.Provider, { value: { tvPackageStore } }, children);
};
export const useTvPackageStore = () => {
    const tvPackageStore = useContext(TvPackageStoreContext);
    return tvPackageStore;
};
